import { render, staticRenderFns } from "./EmailBox.vue?vue&type=template&id=2e5ac660&"
import script from "./EmailBox.vue?vue&type=script&lang=ts&"
export * from "./EmailBox.vue?vue&type=script&lang=ts&"
import style0 from "./EmailBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports